module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<div id=\"confirmation-modal\" title=\"")
    ; __append(escapeFn( confirmationTitle ))
    ; __append("\" style=\"display: none;\">\r\n    <div class=\"row\" style=\"padding: 10px 0 10px 15px; width: 100%\">\r\n        <div class=\" col-md-12\">")
    ; __append( confirmationText )
    ; __append("</div>\r\n    </div>\r\n</div>")
  }
  return __output;

}